// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type SendAstatDailyFacilityClosureMutationVariables = Types.Exact<{
  sendAstatDailyFacilityClosureRequestDTO: Types.SendAstatDailyFacilityClosureRequestDtoInput;
}>;


export type SendAstatDailyFacilityClosureMutationResult = { __typename?: 'Mutation', sendAstatDailyFacilityClosure: string | null };

export const SendAstatDailyFacilityClosureGql = gql`
    mutation SendAstatDailyFacilityClosure($sendAstatDailyFacilityClosureRequestDTO: SendAstatDailyFacilityClosureRequestDTOInput!) {
  sendAstatDailyFacilityClosure(
    sendAstatDailyFacilityClosureRequestDTO: $sendAstatDailyFacilityClosureRequestDTO
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendAstatDailyFacilityClosureInjectable extends Apollo.Mutation<SendAstatDailyFacilityClosureMutationResult, SendAstatDailyFacilityClosureMutationVariables> {
    override document = SendAstatDailyFacilityClosureGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */